module.exports = __webpack_public_path__ + "static/img/nocoupon.9128278.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nocoupon.png
// module id = V8A+
// module chunks = 1